import { Injectable, Injector } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

//ref: https://stackoverflow.com/questions/37482460/getting-instance-of-service-without-constructor-injection
//Now, you can use the AppInjector to find any service in anywhere of your code.
//const myService = AppInjector.get(MyService);
export let AppInjector: Injector;

@Injectable({
  providedIn: 'root',
})
export class InjectorService {

  private isLoaded$$: BehaviorSubject<boolean>;
  private isLoaded: boolean = false;

  constructor(
    private injector: Injector,
  ) {

    this.isLoaded$$ = new BehaviorSubject(this.isLoaded);

  }

  init(): void {

    if (!this.isLoaded) {
      AppInjector = this.injector;

      this.isLoaded = true;
      this.isLoaded$$.next(this.isLoaded);
      console.log("===========", "Injector service loaded.");
    }
  }

  isLoaded$(): Observable<boolean> {
    return this.isLoaded$$.asObservable();
  }

}